module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Patient-Zero.72d1680.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Patient-Zero.jpg
// module id = f2oZ
// module chunks = 0